import { render, staticRenderFns } from "./GroupFormModal.vue?vue&type=template&id=735e51f8&scoped=true&"
import script from "./GroupFormModal.vue?vue&type=script&lang=js&"
export * from "./GroupFormModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupFormModal.vue?vue&type=style&index=0&id=735e51f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e51f8",
  null
  
)

export default component.exports